"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useShowDialogTitle = function (title, onClose) {
    var showDialogTitle = (0, react_1.useMemo)(function () { return !!(title || onClose); }, [onClose, title]);
    return showDialogTitle;
};
exports.default = useShowDialogTitle;
